import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlarmAnimationService } from '@service/alarm-animation.service';
import { OpsAlarmMonitoringService } from '@service/ops-alarms/ops-alarm-monitoring.service';
import { ResponsiveService } from '@service/responsive.service';
import { AlarmStatus } from 'ops/common/models/alarm-level';
import { AlarmMonitoring } from 'ops/common/models/alarm-monitoring';

@Component({
    selector: 'app-alarm-table-row',
    templateUrl: './alarm-table-row.component.html',
    styleUrls: ['./alarm-table-row.component.scss'],
    standalone: false
})
export class AlarmTableRowComponent implements OnInit {
    @Input() alarm: AlarmMonitoring;
    @Input() disableAckButton: boolean = false;

    flag: string;

    @Output() onShowDetail = new EventEmitter<AlarmMonitoring>();

    constructor(
        public responsive: ResponsiveService,
        public alarmMonitoringService: OpsAlarmMonitoringService,
        private alarmAnimation: AlarmAnimationService,
    ) {}

    ngOnInit(): void {
        this.flag = this.statusToFlag(this.alarm.status);
    }

    emitAck() {
        this.alarmMonitoringService.ackAlarm(this.alarm);
    }

    emitShowDetail() {
        this.onShowDetail.emit(this.alarm);
    }

    getNgClass() {
        const isAcked = this.alarmAnimation.getClassByFlag(this.alarm.channel, this.flag);
        if ( isAcked === 0) {
            this.alarm.UnAck = false
        }
        return {
            'flag-alarm': !this.alarm.updatedAt,
            'flag-unack': isAcked !== 0,
            'flag-resolved': this.alarm.updatedAt,
        };
    }

    statusToFlag(alarmStatus) {
        switch (alarmStatus) {
            case AlarmStatus.HIGHHIGH:
                return 'highHigh';
            case AlarmStatus.HIGH:
                return 'high';
            case AlarmStatus.LOW:
                return 'low';
            case AlarmStatus.LOWLOW:
                return 'lowlow';
            case AlarmStatus.FEEDBACK:
                return 'feedbackError';
        }
    }
}
